import React, { useEffect, useState } from 'react';
import { GetAuthToken } from './msal'
import { connect } from 'react-redux';

// Define a selector function
const selectData = state => {
    return {
        token: state.user.userInfo.token
    };
};

const TokenAcquisition = (props) => {
    const [msg, setMsg] = useState("Waiting for log in...");

    useEffect(() => {
        if (props.token === '') {
            GetAuthToken(['api://3834480a-954f-405f-aa20-71e23d719570/Logging.Write'])
                .then(tkn => props.login(tkn))
                .catch(err => {
                    console.log(err)
                    if (String(err).toLowerCase().includes("popup")) {
                        setMsg("Please allow popups to login to the weblogger. Then refresh your browser.")
                    }
                });
        }
    });

    return (<>{msg}</>);
};


export default connect(selectData)(TokenAcquisition);